import React from 'react';
import styled from 'styled-components/macro';
import { IBannersItem } from 'constants/types';
import Breakpoints from 'themes/constants/breakpoints';
import { textTrim } from 'utils/text';
import placeholder from 'media/images/placeholder.jpg';
import useTranslate from 'hooks/useTranslate';
import { useMediaQuery } from 'react-responsive';
import Button, { ButtonThemeType } from 'components/Button/Button';
import { Link } from 'react-router-dom';

const Wrap = styled(Link)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius.card.news};
  cursor: pointer;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  height: 220px;
  padding: 12px 20px;
  gap: 5px;
  &,
  &:hover,
  &:link,
  &:active,
  &:visited {
    color: ${({ theme }) => theme.palette.white};
  }
  @media only screen and (${Breakpoints.MOBILE_M}) {
    gap: 12px;
  }
  @media only screen and (${Breakpoints.TABLET}) {
    height: 242px;
    padding: 24px;
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    height: 242px;
    padding: 36px;
  }
`;
const Name = styled.h2`
  font-size: 24px;
  line-height: 1.05;
  color: inherit;
  @media only screen and (${Breakpoints.MOBILE_M}) {
    line-height: 1.1;
  }
`;
const Img = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  min-width: 100%;
  max-width: 100%;
  overflow: hidden;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0 150px 50px rgba(0, 0, 0, .65) inset;
  }
  & > img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
const Description = styled.div`
  font-size: 10px;
  line-height: 1.2;
  @media only screen and (${Breakpoints.TABLET}) {
    font-size: 16px;
  }
`;
const ButtonBanner = styled(Button)`
  flex-shrink: 0;
  height: 35px;
  max-width: 120px;
  padding: 0;
  margin: auto 0 0 auto;
`;

interface IBannersCard {
  item: IBannersItem
}
export interface IMatchParams {
  categoryId: string;
}

const BannersCard = ({ item }: IBannersCard) => {
  const {
    name,
    description,
    image: imgSrc,
    link,
  } = item;

  const [getText] = useTranslate();

  const isLaptop = useMediaQuery({ query: `(${Breakpoints.LAPTOP})` });

  const nameTextLength = (() => {
    if (isLaptop) return 100;
    return 60;
  })();
  const descriptionTextLength = 100;

  return (
    <Wrap to={link}>
      <Img>
        <img
          src={imgSrc}
          alt={description}
          decoding="async"
          onError={(e: any) => {
            e.target.onerror = null;
            e.target.src = placeholder;
          }}
        />
      </Img>
      <Name>{textTrim(name, nameTextLength)}</Name>
      <Description>{textTrim(description, descriptionTextLength)}</Description>
      <ButtonBanner themeType={ButtonThemeType.SECONDARY}>
        {getText(['words', 'details'])}
      </ButtonBanner>
    </Wrap>
  );
};

export default BannersCard;
